import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  IconButton,
  Tooltip,
} from "@mui/material";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import MDButton from "../../../components/MDButton"; // Assuming you're using Material Dashboard components

// eslint-disable-next-line react/prop-types
function ConvertPiComponent({ id, onConvertPi }) {
  const [open, setOpen] = useState(false);
  const [expectedDate, setExpectedDate] = useState("");
  const [transporterName, setTransporterName] = useState("");

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleConfirm = () => {
    if (expectedDate && transporterName.trim()) {
      onConvertPi(id, expectedDate, transporterName.trim());
      setExpectedDate("");
      setTransporterName("");
      handleClose();
    }
  };

  return (
    <>
      <Tooltip title="Convert to PI">
        <IconButton
          color="info"
          size="small"
          onClick={(e) => {
            e.preventDefault();
            handleOpen();
          }}
        >
          <CheckBoxIcon fontSize="small" />
        </IconButton>
      </Tooltip>

      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Enter Delivery Details</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Expected Delivery Date"
            type="date"
            fullWidth
            value={expectedDate}
            onChange={(e) => setExpectedDate(e.target.value)}
            InputLabelProps={{
              shrink: true,
            }}
          />
          <TextField
            margin="dense"
            label="Transporter Name"
            type="text"
            fullWidth
            value={transporterName}
            onChange={(e) => setTransporterName(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <MDButton onClick={handleClose}>Cancel</MDButton>
          <MDButton onClick={handleConfirm} variant="gradient" color="info">
            Confirm
          </MDButton>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default ConvertPiComponent;
